import React, { useState } from "react";
import { Search, Calendar, TrendingUp } from "lucide-react";
import { siteData } from "../mock";
import { useSearch } from "../context/SearchContext";

export default function Hero() {
  const { submit } = useSearch();
  const [local, setLocal] = useState("");

  const today = new Date().toLocaleDateString("es-DO", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const onSubmit = (e) => {
    e.preventDefault();
    submit(local);
  };

  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${siteData.heroImage})` }}
      />
      <div className="absolute inset-0 np-hero-overlay" />

      <div className="relative max-w-5xl mx-auto px-6 py-20 sm:py-28 text-center text-white np-fade-up">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur border border-white/25 text-xs sm:text-sm font-medium mb-6">
          <Calendar className="w-4 h-4" />
          <span>{today}</span>
        </div>
        <h1 className="font-extrabold text-3xl sm:text-5xl lg:text-6xl leading-tight tracking-tight">
          Números Fácil
        </h1>
        <p className="mt-3 text-lg sm:text-2xl text-blue-50 font-medium">
          Números Fuertes y Calientes de la Lotería Dominicana
        </p>
        <p className="mt-5 max-w-2xl mx-auto text-sm sm:text-base text-blue-100/90">
          Descubre las mejores combinaciones para aumentar tus probabilidades de ganar en los sorteos de hoy.
        </p>

        <form onSubmit={onSubmit} className="mt-8 max-w-xl mx-auto">
          <div className="flex items-center bg-white rounded-full pl-5 pr-2 py-2 shadow-2xl">
            <Search className="w-5 h-5 text-[#1d6cb1]" />
            <input
              type="text"
              value={local}
              onChange={(e) => setLocal(e.target.value)}
              placeholder="Buscar lotería: Nacional, Leidsa, Real..."
              className="flex-1 bg-transparent outline-none px-3 py-2 text-gray-800 text-sm"
            />
            <button
              type="submit"
              className="px-5 py-2.5 rounded-full bg-gradient-to-r from-[#1d6cb1] to-[#2a83ce] text-white text-sm font-semibold hover:shadow-lg hover:scale-[1.02] transition"
            >
              Buscar
            </button>
          </div>
        </form>

        <div className="mt-10 flex items-center justify-center gap-2 text-blue-50/90 text-sm">
          <TrendingUp className="w-4 h-4" />
          <span>Actualizado diariamente · Análisis estadístico y numerología</span>
        </div>
      </div>
    </section>
  );
}
